/**
 * Paid-message cap (limits.message) rule shared by the editor input and the save gate (S8N-13258).
 * Valid only for an integer number >= 1, or a string of decimal digits (no sign, decimal point or
 * surrounding characters) whose integer value is >= 1. Blank, 0, negatives, decimals, non-numeric
 * text, null and undefined are invalid.
 */
export const isValidMessageLimit = value => {
  if (typeof value === 'number') {
    return Number.isInteger(value) && value >= 1;
  }
  if (typeof value === 'string') {
    return /^\d+$/.test(value) && parseInt(value, 10) >= 1;
  }
  return false;
};

export default isValidMessageLimit;
